(function () {
  if (window.LascalShippingEstimatorLoaded) return;
  window.LascalShippingEstimatorLoaded = true;

  let cartRefreshTimer = null;
  let productRefreshTimer = null;
  let configCache = null;

  function getConfig() {
    if (configCache) return configCache;

    const el = document.getElementById("lascal-shipping-estimator-config");
    if (!el) return null;

    try {
      configCache = JSON.parse(el.textContent);
      return configCache;
    } catch (e) {
      return null;
    }
  }

  function toCents(value) {
    if (value === null || value === undefined || value === "") return 0;

    const clean = String(value).replace(/[^\d-]/g, "");
    const parsed = parseInt(clean, 10);

    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function getActiveCurrency() {
    if (window.Currency && Currency.currentCurrency) {
        return Currency.currentCurrency;
    }

    if (window.Shopify && Shopify.currency) {
        return Shopify.currency.active || Shopify.currency.shop;
    }

    const config = getConfig();
    return config?.currency || "EUR";
    }

    function formatAmountForCurrency(cents, currency) {
    const value = toCents(cents) / 100;

    // Match Romanian store display more closely than Intl usually does
    if (currency === "RON") {
        return value.toLocaleString(document.documentElement.lang || "ro-RO", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
        }) + " lei";
    }

    try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency || "EUR"
        }).format(value);
    } catch (e) {
        return value.toFixed(2);
    }
    }

    function formatMoney(cents) {
    return formatAmountForCurrency(cents, getActiveCurrency());
    }

  function translate(key) {
    const config = getConfig();
    return config?.translations?.[key] || "";
  }

  function replaceTokens(text, vars) {
    let output = text || "";

    Object.keys(vars).forEach((key) => {
      output = output.split("[" + key + "]").join(vars[key]);
    });

    return output;
  }

  function getCountryRule() {
    const config = getConfig();
    if (!config) return null;

    const countryIso = config.countryIso || "";
    const rules = config.rules || {};

    return rules[countryIso] || rules.DEFAULT || null;
  }

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let added = 0;

    while (added < days) {
        date.setDate(date.getDate() + 1);

        const day = date.getDay();

        if (day !== 0 && day !== 6) {
        added += 1;
        }
    }

    return date;
    }

    function formatDate(date) {
    try {
        return new Intl.DateTimeFormat(document.documentElement.lang || "en", {
        day: "numeric",
        month: "short"
        }).format(date);
    } catch (e) {
        return date.toLocaleDateString();
    }
    }

    function buildDeliveryEstimate(rule) {
    const config = getConfig();

    if (!config || !rule) return "";

    const fulfillmentMin = toCents(config.fulfillment?.businessDaysMin || 1);
    const fulfillmentMax = toCents(config.fulfillment?.businessDaysMax || 2);
    const transitMin = toCents(rule.transitBusinessDaysMin || 0);
    const transitMax = toCents(rule.transitBusinessDaysMax || 0);

    if (!transitMin || !transitMax) return "";

    const today = new Date();

    const minDate = addBusinessDays(today, fulfillmentMin + transitMin);
    const maxDate = addBusinessDays(today, fulfillmentMax + transitMax);

    const minText = formatDate(minDate);
    const maxText = formatDate(maxDate);

    if (minDate.toDateString() === maxDate.toDateString()) {
        return replaceTokens(translate("delivery_single"), {
        date: minText
        });
    }

    return replaceTokens(translate("delivery_range"), {
        min_date: minText,
        max_date: maxText
    });
    }

    function appendDeliveryEstimate(message, rule) {
    const deliveryEstimate = buildDeliveryEstimate(rule);

    if (!deliveryEstimate) return message;

    return message + " " + deliveryEstimate;
    }



  function buildMessage(amountCents) {
    const config = getConfig();
    const rule = getCountryRule();

    if (!config || !rule) return "";

    const country = config.countryName || config.countryIso || "";
    const carrier = rule.carrier || "";
    const freeThreshold = rule.freeThreshold === null ? null : toCents(rule.freeThreshold);
    const standardPrice = rule.standardPrice === null ? null : toCents(rule.standardPrice);
    const currentAmount = toCents(amountCents);

    if (rule.enabled === false) {
        return replaceTokens(translate("not_available"), {
        country: country,
        carrier: carrier
        });
    }

    if (!freeThreshold || freeThreshold <= 0) {
        if (standardPrice && standardPrice > 0) {
        return appendDeliveryEstimate(
            replaceTokens(translate("shipping_from"), {
            country: country,
            carrier: carrier,
            shipping_price: formatMoney(standardPrice)
            }),
            rule
        );
        }

        if (carrier) {
        return appendDeliveryEstimate(
            replaceTokens(translate("calculated_at_checkout_with_carrier"), {
            country: country,
            carrier: carrier
            }),
            rule
        );
        }

        return appendDeliveryEstimate(
        replaceTokens(translate("calculated_at_checkout"), {
            country: country,
            carrier: carrier
        }),
        rule
        );
    }

    if (currentAmount >= freeThreshold) {
        if (carrier) {
        return appendDeliveryEstimate(
            replaceTokens(translate("free_qualified_with_carrier"), {
            country: country,
            carrier: carrier,
            threshold: formatMoney(freeThreshold)
            }),
            rule
        );
        }

        return appendDeliveryEstimate(
        replaceTokens(translate("free_qualified"), {
            country: country,
            threshold: formatMoney(freeThreshold)
        }),
        rule
        );
    }

    const amountRemaining = freeThreshold - currentAmount;

    if (standardPrice && standardPrice > 0) {
        return appendDeliveryEstimate(
        replaceTokens(translate("shipping_from_add_more"), {
            country: country,
            carrier: carrier,
            shipping_price: formatMoney(standardPrice),
            amount: formatMoney(amountRemaining),
            threshold: formatMoney(freeThreshold)
        }),
        rule
        );
    }

    return appendDeliveryEstimate(
        replaceTokens(translate("add_more"), {
        country: country,
        carrier: carrier,
        amount: formatMoney(amountRemaining),
        threshold: formatMoney(freeThreshold)
        }),
        rule
    );
    }

  function renderEstimator(el, amountCents) {
    if (!el) return;

    const message = buildMessage(amountCents);

    if (!message) {
        el.textContent = "";
        el.style.display = "none";
        return;
    }

    if (el.textContent !== message) {
        el.textContent = message;
    }

    el.style.display = "block";
   }

  function getSelectedProductPrice() {
    const select = document.querySelector("select.product__select");

    if (select) {
      const selectedOption = select.options[select.selectedIndex];

      if (selectedOption?.dataset?.priceCents) {
        return toCents(selectedOption.dataset.priceCents);
      }
    }

    const pdpEstimator = document.querySelector('[data-shipping-estimator="pdp"]');

    if (pdpEstimator?.dataset?.productPriceCents) {
      return toCents(pdpEstimator.dataset.productPriceCents);
    }

    return 0;
  }

  function refreshProductEstimators() {
    const targets = document.querySelectorAll('[data-shipping-estimator="pdp"]');
    if (!targets.length) return;

    const selectedProductPrice = getSelectedProductPrice();

    fetchCart()
        .then((cart) => {
        const cartTotal = toCents(cart.total_price);
        const estimateAmount = cartTotal + selectedProductPrice;

        targets.forEach((el) => {
            renderEstimator(el, estimateAmount);
        });
        })
        .catch(() => {
        // Fallback: if cart.js fails, still show estimate based on the selected product
        targets.forEach((el) => {
            renderEstimator(el, selectedProductPrice);
        });
        });
    }

  function scheduleProductRefresh(delay) {
    clearTimeout(productRefreshTimer);
    productRefreshTimer = setTimeout(refreshProductEstimators, delay || 0);
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    }).then((res) => res.json());
  }

  function refreshCartEstimators() {
    const targets = document.querySelectorAll('[data-shipping-estimator="cart"]');
    if (!targets.length) return;

    fetchCart()
      .then((cart) => {
        const cartTotal = toCents(cart.total_price);

        targets.forEach((el) => {
          renderEstimator(el, cartTotal);
        });
      })
      .catch(() => {
        targets.forEach((el) => {
          el.textContent = "";
          el.style.display = "none";
        });
      });
  }

  function scheduleCartRefresh(delay) {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCartEstimators, delay || 0);
  }

  function runCartRefreshPasses() {
    [0, 80, 250, 600].forEach((delay) => {
      setTimeout(refreshCartEstimators, delay);
    });
  }

  function init() {
    refreshProductEstimators();
    refreshCartEstimators();

    document.addEventListener("change", (event) => {
      if (event.target && event.target.matches("select.product__select")) {
        scheduleProductRefresh(50);
      }
    });

    document.addEventListener("click", (event) => {
      if (
        event.target.closest(".product-variant__color") ||
        event.target.closest(".product__card-color")
      ) {
        scheduleProductRefresh(100);
      }

      if (
        event.target.closest(".product__form-button") ||
        event.target.closest(".product__card-add-cart") ||
        event.target.closest("[data-cart-submit]") ||
        event.target.closest("[data-cart-update]") ||
        event.target.closest("[data-cart-remove]")
        ) {
        runCartRefreshPasses();

        // Also refresh PDP estimator because the cart total may have changed
        [200, 600, 1000].forEach((delay) => {
            setTimeout(refreshProductEstimators, delay);
        });
        }
    });

    const cartRoot = document.querySelector(".ajax-cart");

    if (cartRoot) {
      const observer = new MutationObserver(() => {
        scheduleCartRefresh(120);
      });

      observer.observe(cartRoot, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();